var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204 302c-30 0-58-12-78-32s-32-48-32-78 12-56 32-76 48-32 78-32 56 12 76 32 32 46 32 76-12 58-32 78-46 32-76 32zm0-234c-36 0-66 14-90 36-22 22-36 54-36 88 0 36 14 66 36 90 24 22 54 36 90 36 34 0 66-14 88-36 22-24 36-54 36-90 0-34-14-66-36-88s-54-36-88-36zm-20 294h38c4 0 6 2 10 4 2 2 4 6 4 10s-2 8-4 10c-4 2-6 4-10 4h-38c-2 0-6-2-8-4-4-2-4-6-4-10s0-8 4-10c2-2 6-4 8-4zm184-234c-10-38-32-70-60-92-30-22-66-36-104-36-40 0-76 14-104 36-30 22-52 54-62 92v2l-4 2c-10 0-16 6-22 12S2 160 2 168v50c0 8 4 14 8 22 4 6 10 10 18 12l4 2v24c0 30 12 56 32 76 18 18 44 30 74 30h18v4c4 6 8 10 12 14 4 2 10 4 16 4h38c8 0 16-4 22-8 4-6 8-14 8-22s-4-16-8-22c-6-6-14-8-22-8h-38c-6 0-12 2-16 4-4 4-8 8-12 14v4h-18c-24 0-46-10-62-26-18-16-26-38-26-64v-32c0-2-2-4-4-6 0 0-4-2-6-2-6 0-10-2-14-6s-6-10-6-14v-50c0-6 2-10 6-14s8-6 14-6h4c2 0 4-2 6-2 0-2 2-4 2-6 8-36 28-66 54-88s60-36 98-36c36 0 70 14 96 36 28 22 48 52 54 88 0 2 2 4 4 6 0 0 2 2 4 2h4c6 0 10 2 14 6s6 8 6 14v50c0 4-2 10-6 14s-8 6-14 6c-2 0-4 2-6 2-2 2-2 4-2 6s0 4 2 6 4 2 6 2c10 0 20-4 26-10 8-8 12-16 12-26v-50c0-8-4-18-10-24-4-6-12-12-22-12l-2-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.ed1267e90beaa6e15f25ba148c3328d9.svg";
export { ForwardRef as ReactComponent };